
<ngx-loading-bar></ngx-loading-bar>
<!-- <section class="container"> -->
<router-outlet></router-outlet>
<app-footer></app-footer>
<div id="app-notifications-container" class="container"></div>
<!-- </section> -->
<!--  -->